import React from 'react';
import { BadgeQRCode } from '../../qrCode/BadgeQRCode';
import ReactPDF from '@react-pdf/renderer';
import { BadgePDFProps, PDFBadgeInfo, BadgePrintExtension } from '../../../types/badge';
import PDFDocument from '../../pdf/pdfDocument/PDFDocument';

export class BadgePDF implements BadgePrintExtension {
  async getBlob(options: BadgePDFProps, badgeInfo: PDFBadgeInfo) {
    try {
      const { doubleSidedBadge, qrCode, paperSize, badgeIcons, type, fonts } = options;
      qrCode.src = await BadgeQRCode.getQrCodeSrc(qrCode);
      return await ReactPDF.pdf(
        <PDFDocument
          type={type}
          base64Images={options.base64Images!}
          badgeInfo={badgeInfo}
          paperSize={paperSize}
          doubleSidedBadge={doubleSidedBadge}
          qrCodeUrl={qrCode.src}
          badgeSuffix={options?.badgeSuffix}
          footerInfo={options.footerInfo!}
          badgeIcons={badgeIcons}
          fonts={fonts}
        />
      ).toBlob();
    } catch (err) {
      throw new Error((err as Error).message);
    }
  }
}
